export default __webpack_public_path__ + "dist/media/look-nda.b80c42f0.svg";